const urlForPostShare = ({ postId, prefix }) => {
	let url = `/post/share/${postId}`
	if (prefix) {
		url = (prefix[prefix.length - 1] === '/' ? prefix.substr(0, prefix.length - 1) : prefix) + url
	}
	return url
}

export default urlForPostShare



// WEBPACK FOOTER //
// ./src/utilities/urlForPostShare.js